import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import BlogDetailsMain from '../Components/Blog/BlogDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import posts from '../Components/data/data-post.json'

function BlogDetails() {
    const { slug } = useParams();
    const isLegacyNumericRoute = typeof slug === 'string' && /^\d+$/.test(slug);
    const legacyPost = isLegacyNumericRoute
        ? posts.find((post) => post.id === parseInt(slug, 10))
        : null;

    if (legacyPost) {
        return <Navigate to={`/blog/${legacyPost.slug}`} replace />;
    }

    const selectedPost = slug ? posts.find((post) => post.slug === slug) : null;

    return (
        <>
            <HeaderOne />
            <Breadcrumb
                title={selectedPost ? selectedPost.title : 'Blog Details'}
            />
            <BlogDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default BlogDetails
